module.exports = __webpack_public_path__ + "assets/retina_CircleTangentPLDetailed.c1c8dc2c91936ece9db160533459217e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CircleTangentPLDetailed.png
// module id = 650
// module chunks = 0